module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_Race_08.b200fb71.jpg";